import { gql } from '@apollo/client'

export default gql(`
query listMediaCategories($project: String) {
    listMediaCategories (project: $project){
          id
          label
          type
          usageCount
          isActive
    }
}`)
